// extracted by mini-css-extract-plugin
export var backupIcon = "_sv-1";
export var image = "_sv-0";